// extracted by mini-css-extract-plugin
module.exports = {"APINavigationDisabled__tooltip__3O_YY":"APINavigationDisabled__tooltip__3O_YY","APINavigationDisabled__error__Cuk1V":"APINavigationDisabled__error__Cuk1V"};